import { render } from "./ActivePlenItemDialog.vue?vue&type=template&id=53e7abb8&scoped=true"
import script from "./ActivePlenItemDialog.vue?vue&type=script&lang=js"
export * from "./ActivePlenItemDialog.vue?vue&type=script&lang=js"

import "./ActivePlenItemDialog.vue?vue&type=style&index=0&id=53e7abb8&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e7abb8"]])

export default __exports__